import { render, staticRenderFns } from "./ManageAreaMatrix.vue?vue&type=template&id=430a00ab"
import script from "./ManageAreaMatrix.vue?vue&type=script&lang=js"
export * from "./ManageAreaMatrix.vue?vue&type=script&lang=js"
import style0 from "./ManageAreaMatrix.vue?vue&type=style&index=0&id=430a00ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports